<template>
  <div class="discounts">
    <BaseBanner cookie-name="welcome">
      <template #title>Welcome 🎉</template>
      <template #content>View the setup guide to get started.</template>
      <template #button><BaseButton text="View setup guide" theme="white" @click.native="$router.push('/help/guides')"/></template>
    </BaseBanner>
    <div class="header">
      <div class="page-title">Discounts</div>
      <div class="buttons">
        <img class="info" src="@/assets/img/info.svg" @click="$router.push('/help/guides')" />
        <BaseButton text="Add a discount" @click.native="$shopify.redirectToAdminSection('discounts')" />
      </div>
    </div>
    <BaseTable
      :properties="[
        { title: 'Name', slot: 'name' },
        { title: 'Status', slot: 'status' }
      ]"
      :items="discounts"
      :loading="loading"
      :finished="finished"
      @fetch-more="filters.page++"
      @selected="handleSelected($event.id)"
    >
      <template #name="{ item }">
        <div class="code">{{ item.details.codeDiscount.title }}</div>
        <div class="summary">{{ item.details.codeDiscount.shortSummary || item.details.codeDiscount.summary }}</div>
      </template>
      <template #status="{ item }">
        <BaseBadge
          :text="item.details.codeDiscount.status === 'EXPIRED' ? 'Expired' : item.active ? 'On' : 'Off'"
          :theme="item.details.codeDiscount.status === 'EXPIRED' || !item.active ? 'gray' : 'green'"
        />
      </template>
    </BaseTable>
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable/BaseTable'
import BaseButton from '@/components/BaseButton/BaseButton'
import BaseBadge from '@/components/BaseBadge/BaseBadge'
import BaseBanner from '@/components/BaseBanner/BaseBanner'
import discountService from '@/services/api/services/discountService'
export default {
  components: {
    BaseTable,
    BaseButton,
    BaseBadge,
    BaseBanner
  },
  created() {
    this.resetSearch()
  },
  data: () => ({
    loading: true,
    finished: false,
    discounts: [],
    filters: null
  }),
  watch: {
    filters: {
      deep: true,
      handler(filters) {
        this.fetchProducts(filters)
      }
    }
  },
  methods: {
    resetSearch() {
      this.finished = false
      this.discounts = []
      this.filters = {
        page: 1
      }
    },
    async fetchProducts(filters) {
      this.loading = true
      const { items, hasNextPage } = await discountService.findAll(filters)
      if (!hasNextPage) this.finished = true
      this.discounts = [...this.discounts, ...items]
      this.loading = false
    },
    handleSelected(id) {
      this.$router.push({ name: 'widget-discounts-discount', params: { id } })
    }
  }
}
</script>

<style lang="scss" scoped>
.discounts {
  width: 100%;
  display: grid;
  grid-auto-flow: row;
  grid-gap: var(--spacing-5);
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.buttons {
  display: grid;
  grid-auto-flow: column;
  grid-gap: var(--spacing-2);
}
.info {
  height: 1.4rem;
  padding: var(--spacing-2);
  box-sizing: content-box;
  cursor: pointer;
}
.page-title {
  font-size: var(--fs-title);
  font-weight: var(--fw-medium);
}
.code {
  color: var(--color-black-1);
  font-weight: var(--fw-medium);
  margin-bottom: var(--spacing-2);
}
.summary {
  color: var(--color-black-1);
}
</style>
